import axiosInstance from "../utils/axios"
import { parseFilenameFromDisposition } from "../utils/download";
// import { handleApiError } from "../utils/errorHandler"

export const rccService = {
  export: async (params = {}) => {
    const response = await axiosInstance.get(`/rcc/export`, { 
      params,
      responseType: 'blob'
    })
    const disposition = response.headers["content-disposition"];
    const filename = parseFilenameFromDisposition(disposition) || "sambungan-baru-rcc.xlsx";
    return { blob: response.data, filename };
  },
  exportRegistrationData: async (id) => {
    const response = await axiosInstance.get(`/rcc/${id}/export-pdf`, { 
      responseType: 'blob'
    })
    const disposition = response.headers["content-disposition"];
    const filename = parseFilenameFromDisposition(disposition) || "data-registrasi.pdf";
    return { blob: response.data, filename };
  },
  dispatchMeterInstallation: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-meter-installation`, body)
    return response.data
  },
  dispatchPEPMInstallation: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-pepm-installation`, body)
    return response.data
  },
  dispatchRccOfficerAdministrasiToRcc: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-administrasi-to-rcc`, body)
    return response.data
  },
  dispatchRccOfficerProposal: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-proposal`, body)
    return response.data
  },
  dispatchPEPMDocumentDED: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-pepm-ded`, body)
    return response.data
  },
  dispatchDistributionDRO: async (id, body) => {
    const response = await axiosInstance.post(`/rcc/${id}/dispatch-distribution-officer-dro`, body)
    return response.data
  },
  dispatchMeterSizing: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-meter-sizing`, body)
    return response.data
  },
  dispatchModellingOfficer: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-modelling-officer`, body)
    return response.data
  },
  dispatchDistributionOfficer: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/dispatch-distribution-officer`, body)
    return response.data
  },
  verify: async (id, body) => {
    const response = await axiosInstance.postForm(`/rcc/${id}/verify`, body)
    return response.data
  },
  getForm: async (id) => {
    const response = await axiosInstance.get(`/rcc/${id}/form`)
    return response.data
  },
  getDocuments: async (id) => {
    const response = await axiosInstance.get(`/rcc/${id}/documents`)
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get(`/rcc/${id}/detail`)
    return response.data
  },
  reject: async (id, data) => {
    const response = await axiosInstance.post(`/rcc/${id}/reject`, data)
    return response.data
  },
}